// Thư mục: src/stores/dmLoaiXeStore.js
import { defineStore } from "pinia";
import { DmLoaiXeApi } from "@/services/dmLoaiXeService";

export const useDmLoaiXeStore = defineStore("dmLoaiXe", {
  state: () => ({
    isLoading: false,
    error: null,
    items: [],

    // Paging
    page: 0,
    size: 10,
    sort: "id,desc",
    totalPages: 1,
    totalElements: 0,
  }),

  getters: {
    currentPage(state) {
      return state.page + 1;
    },
  },

  actions: {
    setPage(p1) {
      const p0 = Math.max(0, p1 - 1);
      if (p0 !== this.page) this.page = p0;
    },
    setSize(s) {
      this.size = s;
      this.page = 0;
    },

    async fetchList() {
      this.isLoading = true;
      this.error = null;
      try {
        const data = await DmLoaiXeApi.list({
          page: this.page,
          size: this.size,
          sort: this.sort,
        });
        this.items = data.content || [];
        this.totalPages = data.totalPages ?? 1;
        this.totalElements = data.totalElements ?? this.items.length;
        this.page = data.number ?? 0;
        this.size = data.size ?? this.size;
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi tải danh sách loại xe";
      } finally {
        this.isLoading = false;
      }
    },

    // Action này nhận DmLoaiXeRequestDto
    async createLoaiXe(form) {
      await DmLoaiXeApi.create(form);
      await this.fetchList();
    },

    // Action này nhận DmLoaiXeRequestDto
    async updateLoaiXe(id, form) {
      await DmLoaiXeApi.update(id, form);
      await this.fetchList();
    },

    async deleteLoaiXe(id) {
      await DmLoaiXeApi.remove(id);
      if (this.items.length === 1 && this.page > 0) this.page -= 1;
      await this.fetchList();
    },
  },
});
